/*
 * Tupaia
 * Copyright (c) 2017 - 2020 Beyond Essential Systems Pty Ltd
 */
import React from "react";
import PropTypes from "prop-types";
import MuiButton from "@material-ui/core/Button";
import styled from "styled-components";
import InputBase from "@material-ui/core/InputBase";
import MuiIconButton from "@material-ui/core/IconButton";
import MuiSearchIcon from "@material-ui/icons/Search";
import CancelIcon from "@material-ui/icons/Cancel";

const Form = styled.form`
  display: flex;
  margin-bottom: 1rem;

  @media screen and (max-width: 480px) {
    flex-direction: column;
  }
`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  border-radius: 3px 0 0 3px;
  background: white;

  @media screen and (max-width: 480px) {
    border-radius: 3px;
  }
`;

const Input = styled(InputBase)`
  flex: 1;
  height: 3rem;
`;

const SearchIcon = styled(MuiSearchIcon)`
  margin: 0 0.3rem 0 0.5rem;
  font-size: 1.3rem;
`;

const ClearButton = styled(MuiIconButton)`
  margin: 1px 0 0 0;
  padding: 0.5rem;

  &:hover {
    background: none;
    color: ${(props) => props.theme.palette.primary.main};
  }

  .MuiSvgIcon-root {
    font-size: 1.1rem;
  }
`;

const SearchButton = styled(MuiButton)`
  font-size: 0.9rem;
  text-transform: none;
  font-weight: 600;
  line-height: 1rem;
  color: white;
  background: ${(props) => props.theme.palette.primary.main};
  width: 6.5rem;
  border-radius: 0 3px 3px 0;
  align-self: stretch;

  &:hover {
    background: #007acd;
  }

  @media screen and (max-width: 480px) {
    border-radius: 3px;
    height: 50px;
    margin-top: 10px;
  }
`;

const getButtonText = (isLoading) => {
  if (isLoading) {
    return "Searching";
  }
  return "Search";
};

export const SearchForm = ({
  value,
  onChange,
  onSubmit,
  onClear,
  isLoading,
}) => {
  return (
    <Form onSubmit={onSubmit}>
      <SearchBox>
        <SearchIcon />
        <Input
          value={value}
          onChange={onChange}
          placeholder="Enter your test ID (e.g. XNH7821)"
          name="search"
          id="search"
          autoComplete="off"
          error={true}
        />
        {value && (
          <ClearButton onClick={onClear} aria-label="clear">
            <CancelIcon />
          </ClearButton>
        )}
      </SearchBox>
      <SearchButton type="submit">{getButtonText(isLoading)}</SearchButton>
    </Form>
  );
};

SearchForm.propTypes = {
  status: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.string,
  onClear: PropTypes.func,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
};

SearchForm.defaultProps = {
  status: "idle",
  onClear: () => {},
  onChange: () => {},
  onSubmit: () => {},
  inputValue: null,
  className: null,
};
